import { Button } from "@mui/material"
import { useState } from "react"
import { ReactComponent as CopyIcon} from "../../../assets/copy-icon.svg"
import { ReactComponent as HoveredCopyIcon} from "../../../assets/hovered-copy.svg"

export default function CopyButtons({ setCopyStatus, secret, privKey }) {    

    const [keyHovered, setKeyHovered] = useState(false)
    const [secretHovered, setSecretHovered] = useState(false)


    function toggleKeyHovered() {
        setKeyHovered(!keyHovered)
    }

    function toggleSecretHovered() {
        setSecretHovered(!secretHovered)
    }
    
    function paste(type) {
        type === "key" ? navigator.clipboard.writeText(privKey).then(
            () => setCopyStatus("success"),
            () => setCopyStatus("fail")
        ) : navigator.clipboard.writeText(secret).then(
            () => setCopyStatus("success"),
            () => setCopyStatus("fail")
        )
    }

    
    return(
        <>
            <div style={{
                display: privKey==="" ? "none" : "flex",
                flexDirection: "column"
            }}
            onMouseLeave={() => {
                setKeyHovered(false)
                setSecretHovered(false)
            }}
            >
                <Button
                    onClick={() => paste("key")}
                    sx={{
                      color: "#fff",
                      backgroundColor: "transparent !important",
                      textTransform: "none",
                      margin: "10px 8px 0px",   
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "18px",
                      justifyContent: "left",
                      fontFamily: "Averta",
                      "& .MuiButton-endIcon": {
                        marginLeft: "auto",
                      },
                      "&:hover" : {color: "#118EA0"}
                    }}
                    endIcon={keyHovered ? <HoveredCopyIcon /> : <CopyIcon />}
                    onMouseEnter={() => toggleKeyHovered()}
                    onMouseLeave={() => toggleKeyHovered()}
                >Private Key</Button>
                <Button
                    onClick={() => paste("secret")}
                    sx={{
                      color: "#fff",
                      backgroundColor: "transparent !important",
                      textTransform: "none",
                      margin: "10px 8px 0px",   
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "18px",
                      justifyContent: "left",
                      fontFamily: "Averta",
                      "& .MuiButton-endIcon": {
                        marginLeft: "auto",
                      },
                      "&:hover" : {color: "#118EA0"}
                    }}
                    endIcon={secretHovered ? <HoveredCopyIcon /> : <CopyIcon />}
                    onMouseEnter={() => toggleSecretHovered()}
                    onMouseLeave={() => toggleSecretHovered()}
                >Secret</Button>
            </div>
        </>
    )
}